export const EventCacheAPI = {

    created() {
        this._eventCache = {};
        this._requestVerificationCodes = {};
        this._lastRequestKeys = {};
    },

    methods: {
        startRequest(requestName) {
            if (!this._requestVerificationCodes[requestName]) {
                this._requestVerificationCodes[requestName] = 0;
            }
            return ++this._requestVerificationCodes[requestName];
        },

        isValidRequest(requestName, code) {
            return this._requestVerificationCodes[requestName] === code;
        },

        getCachedEvents(url, startDate, endDate) {
            return this._eventCache[this._cacheKey(url, startDate, endDate)];
        },

        setCachedEvents(events, url, startDate, endDate) {
            this._eventCache[this._cacheKey(url, startDate, endDate)] = events;
        },

        _cacheKey(url, startDate, endDate) {
            return url + '_' + (startDate && startDate.unix()) + '_' + (endDate && endDate.unix());
        }
    },
};
